import { useState, useEffect, useRef } from 'react';
import './SingleSelect.scss';
import ArrowDown from "../../assets/images/ArrowDown.svg";
import ArrowUp from "../../assets/images/ArrowUp.svg";

const SingleSelect = ({ 
  options = [], 
  initialValue = null, 
  name = '', 
  placeholder = 'Select an option...',
  handleChange,
  selected,
  className = '' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialValue);
  const dropdownRef = useRef(null);

  const isEqual = (a, b) => {
    if (typeof a === 'object' && typeof b === 'object') {
      return JSON.stringify(a) === JSON.stringify(b);
    }
    return a === b;
  };

  const getSelectedLabel = () => {
    const option = options.find(opt => {
      return typeof opt === 'object'
        ? opt.value === selectedOption || JSON.stringify(opt.value) === JSON.stringify(selectedOption)
        : opt === selectedOption;
    });
    return option ? (typeof option === 'object' ? option.label : option) : '';
  };

  const handleSelectOption = (option) => {
    const value = typeof option === 'object' ? option.value : option;
    setSelectedOption(value);
    setIsOpen(false);
    handleChange(name, value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setSelectedOption(initialValue);
  }, [initialValue]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className={`single-select ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className="select-button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className={!selectedOption ? 'placeholder' : ''}>
          {selectedOption ? getSelectedLabel() : placeholder}
        </span>
        <span className="chevron">
          {isOpen ? <img src={ArrowUp} alt="icon"/> : <img src={ArrowDown} alt="icon"/>}
        </span>
      </button>

      {isOpen && (
        <div className="options-container">
          {options.length > 0 ? (
            options.map((option, index) => {
              const value = typeof option === 'object' ? option.value : option;
              const label = typeof option === 'object' ? option.label : option;
              const isSelected = isEqual(value, selectedOption);

              return (
                <div
                  key={index}
                  onClick={() => handleSelectOption(option)}
                  className={`option ${isSelected ? 'selected' : ''}`}
                  role="option"
                  aria-selected={isSelected}
                >
                  {label}
                </div>
              );
            })
          ) : (
            <div className="no-options">No options available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleSelect;
